import React from 'react';
import { useMutation } from '@apollo/react-hooks';

import { SEND_PUSH_NOTIFICATIONS } from '../../../../graphql/Campaign';

export default ({ campaign, onClose }) => {
  const [title, setTitle] = React.useState(
    'Nieuwe BUFFL survey beschikbaar! 🐃'
  );
  const [message, setMessage] = React.useState(
    'Laat jouw mening weten en verdien tokens! 💌'
  );

  const [sendPushNotifications, { loading, data, error }] = useMutation(
    SEND_PUSH_NOTIFICATIONS
  );

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: 400,
        backgroundColor: 'white',
        transform: 'translate(-50%, -50%)',
        borderRadius: 8,
        border: '1px solid rgba(0, 0, 0, 0.1)',
        padding: 16
      }}
    >
      {loading && <span>Sending...</span>}
      {data && (
        <>
          <div
            style={{
              fontSize: 14,
              marginBottom: 16,
              color: '#8b8b8d'
            }}
          >
            Sent {data.sendPushNotifications.notificationsSent} push
            notifications
          </div>
          <center>
            <button
              type="button"
              onClick={onClose}
              className="button secondary-active"
              style={{ margin: 8 }}
            >
              Close
            </button>
          </center>
        </>
      )}
      {!loading && !data && !error && (
        <>
          <span
            style={{
              fontSize: 14,

              color: '#8b8b8d'
            }}
          >
            Notification Title
          </span>
          <input
            type="text"
            value={title}
            onChange={e => setTitle(e.target.value)}
            style={{
              fontFamily: 'Open Sans Regular',
              fontSize: 14,
              border: 0,
              outline: 'none',
              display: 'block',
              width: '100%',
              backgroundColor: '#ffffff',
              color: '#000000',
              borderBottom: '1px solid #eeeeee',
              height: 25,
              lineHeight: 25,
              marginBottom: 25,
              overflow: 'hidden',
              resize: 'none'
            }}
          />
          <span
            style={{
              fontSize: 14,

              color: '#8b8b8d'
            }}
          >
            Notification Message
          </span>
          <input
            type="text"
            value={message}
            onChange={e => setMessage(e.target.value)}
            style={{
              fontFamily: 'Open Sans Regular',
              fontSize: 14,
              border: 0,
              outline: 'none',
              display: 'block',
              width: '100%',
              backgroundColor: '#ffffff',
              color: '#000000',
              borderBottom: '1px solid #eeeeee',
              height: 25,
              lineHeight: 25,
              marginBottom: 25,
              overflow: 'hidden',
              resize: 'none'
            }}
          />
          <center>
            <button
              type="button"
              onClick={e => {
                e.stopPropagation();
                if (
                  // eslint-disable-next-line
                  window.confirm(
                    `Are you sure you wish to send a push notification with title "${title}" and message "${message}"?`
                  )
                )
                  sendPushNotifications({
                    variables: {
                      campaignId: campaign.id,
                      title,
                      message
                    }
                  });
              }}
              className="button primary-active"
              style={{ margin: 8 }}
            >
              Send Push Notifications
            </button>
            <button
              type="button"
              onClick={onClose}
              className="button secondary-active"
              style={{ margin: 8 }}
            >
              Cancel
            </button>
          </center>
        </>
      )}
    </div>
  );
};
